export enum ExternalProvisioner {
    ACTIVE_DIRECTORY = 'ACTIVE_DIRECTORY',
    PEOPLE_HR = 'PEOPLE_HR',
    TRI_NET = 'TRI_NET',
    SAGE_HR = 'SAGE_HR',
    MERGE_DEV = 'MERGE_DEV'
}